import Vue from 'vue';
import Vuex from 'vuex';
import actions from './store/actions';
import createPersistedState from 'vuex-persistedstate';
import getters from './store/getters';
import mutations from './store/mutations';
/**
 * Import the individual pieces
 */
import state from './store/state';

/**
 * Init Vuex
 */
Vue.use(Vuex);

/**
 * Setup the store
 */
export default new Vuex.Store({
    /**
     * Main state property. Can be accessed from component: this.$store.state.gameURL
     */
    state,

    /**
     * Computed properties for state.
     */
    getters,

    /**
     * Mutations are for sync code/changes. Can be called: this.$store.commit('changeGame', param)
     */
    mutations,

    /**
     * Actions are for async code. Can be called: this.$store.dispatch('actionName', param)
     */
    actions,

    /**
     * Plugins
     */
    'plugins': [createPersistedState({
        reducer(state,paths) {

            const reducer = Object.assign({},state);
            // state which you don't want to persist.
            delete reducer.interactionGroups;
            delete reducer.selectedSequence;
            delete reducer.showAddCardToSequenceModal;
            delete reducer.showAddMediaToCardModal;
            delete reducer.showAddSequenceToPolicyModal;
            delete reducer.showCardHelpModal;
            delete reducer.showColdDeckModal;
            delete reducer.showCreateCardModal;
            delete reducer.showCreateLocalRecordModal;
            delete reducer.showCreateMarketModal;
            delete reducer.showCreateProductLocalRecordModal;
            delete reducer.showCreateMediaLibraryLocalRecordModal;
            delete reducer.showCreateProductGroupModal;
            delete reducer.showCreateMediaLibraryModal;
            delete reducer.showCreateProductModal;
            delete reducer.showDeprecateMediaModal;
            delete reducer.showLogoutModal;
            delete reducer.showUpateThumbModal;
            delete reducer.showUpdateThumbModal;
            delete reducer.showUploadMediaModal;
            delete reducer.showUploadProductImageModal;
            delete reducer.showCopyVolumeLinksModal;
            delete reducer.showCopyLocalRecordModal;
            delete reducer.showCardIconModal;
            delete reducer.showDeleteProductModal;
            delete reducer.showRestoreProductModal;
            delete reducer.showDeleteRecordModal;
            delete reducer.tenant;
            delete reducer.user;

            return reducer;
        }
    })]
});



// WEBPACK FOOTER //
// ./src/store.js